import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getCookieConsent } from "./CookieBanner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const injectMeta = (id) => {
  if (window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("init", id);
  window.fbq("track", "PageView");
};

const injectGoogle = (id) => {
  if (window.__flGtagLoaded) return;
  window.__flGtagLoaded = true;
  if (id.startsWith("GTM-")) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const s = document.createElement("script"); s.async = true; s.src = `https://www.googletagmanager.com/gtm.js?id=${id}`; document.head.appendChild(s);
    return;
  }
  const s = document.createElement("script"); s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`; document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
};

export const TrackingScripts = () => {
  const { pathname } = useLocation();
  const [cfg, setCfg] = useState(null);
  const [consent, setConsent] = useState(() => getCookieConsent()?.choice);

  useEffect(() => {
    axios.get(`${API}/tracking`).then(r => setCfg(r.data)).catch(() => setCfg({}));
    const onConsent = () => setConsent(getCookieConsent()?.choice);
    window.addEventListener("fl:cookie-consent", onConsent);
    return () => window.removeEventListener("fl:cookie-consent", onConsent);
  }, []);

  useEffect(() => {
    if (!cfg?.google_site_verification) return;
    let m = document.querySelector('meta[name="google-site-verification"]');
    if (!m) { m = document.createElement("meta"); m.name = "google-site-verification"; document.head.appendChild(m); }
    m.content = cfg.google_site_verification;
  }, [cfg]);

  useEffect(() => {
    if (!cfg || !cfg.enabled || consent !== "accepted") return;
    if (cfg.meta_pixel_id) injectMeta(cfg.meta_pixel_id);
    if (cfg.google_tag_id) injectGoogle(cfg.google_tag_id);
  }, [cfg, consent]);

  useEffect(() => {
    if (consent !== "accepted") return;
    if (window.fbq) window.fbq("track", "PageView");
    if (window.gtag && cfg?.google_tag_id && !cfg.google_tag_id.startsWith("GTM-")) window.gtag("event", "page_view", { page_path: pathname });
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
